import axios from "axios";
import React, {useEffect, useState, useRef, Fragment} from "react";
import {Link, NavLink, useParams, useNavigate, useLocation} from "react-router-dom"
import { render } from "react-dom";
import clientconfigwebapp, {
    empty_bk,
    redirectbh,
    is_phone_hk,
    convert_to_english_strhk,
    scrollTo_uphk,
    show_menu_hh,
    check_login_appbk,
    Token_get_appbk,
    FormatNumberByhkh,
    Agent_by_user_get_appbk,
    modal_select_agent_show_hide,
    Cart_get_list_product, redirectbh_typeb, Agent_set_by_user, modal_login_reg_bk_show,
} from '../../clientconfigwebapp';
import { ToastContainer, toast } from 'react-toastify';
import logo_main from "../../assets/images/logo-web-app.svg";
import Master_Front from "../../pages/Master_Front";



import ReactFullPageLoadinghk from "../../components/layaout/LoadingFullpagehk";
import Grid from '@mui/material/Grid';
import {Button} from "@mui/material";



const serialize = require('form-serialize');


const Login_Message = () => {

    const location_get_urlbk = useLocation();
    const redirect_navigate = useNavigate();

    /*  start profile */
    const [wallet_balance, setData_wallet_balance] = useState('0');
    const [first_name_profile,setData_first_name_profile] = useState('');
    const [last_name_profile,setData_last_name_profile] = useState('');
    /*  end profile */

    const [loadinghkfullshow, Setloadinghkfullshow] = useState("false");



    function popups_address_new_OpenHandler () {

    }

    function popups_address_new_CloseHandler () {

    }

    useEffect(() => {

        scrollTo_uphk();
        localStorage.removeItem("tokenacess");

        var id_get_agent_Get=Agent_by_user_get_appbk("id_agent");
        var agent_name_Get=Agent_by_user_get_appbk("agent_name");

        console.log(id_get_agent_Get,"id_get_agent_Get");
         /////localStorage.clear();

       if(!empty_bk(id_get_agent_Get) && !empty_bk(agent_name_Get)){     Agent_set_by_user(id_get_agent_Get,agent_name_Get)      }

        document.getElementById("redirect_id_loginreg").value="panel/my-courses/";



    }, [location_get_urlbk]);




const Handler_login_show = (event) => {
modal_login_reg_bk_show("login_reg_check_view_modal");
}




    return (
        <>
            <Master_Front   wallet_balance={wallet_balance} first_name_profile={first_name_profile} last_name_profile={last_name_profile} >
                <ReactFullPageLoadinghk loadinghk={loadinghkfullshow}  />

                <ToastContainer />

                <Fragment>

                    <Grid container direction="row" spacing={2} style={{paddingTop:"14px"}}>

                        <Grid  item className="item_inputbk" lg={12} md={12} sm={12} xs={12} style={{marginTop:"4px"}}>


<div className={"message_box_login"}>
<img  src={logo_main} />
<span>کاربر گرامی، باید در وب اپ حساب کاربری بسازید.</span>

    <button onClick={Handler_login_show} type="button" className="btn-lgoin-page" style={{ color: "white" }}><svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" style={{ color: "white", fill: "white" }}><path d="M12 10C14.2091 10 16 8.20914 16 6C16 3.79086 14.2091 2 12 2C9.79086 2 8 3.79086 8 6C8 8.20914 9.79086 10 12 10Z" stroke="var(--c7)" strokeWidth="1.5" style={{ fill: "white", stroke: "white" }}/><path opacity={1} d="M20 17.5C20 19.985 20 22 12 22C4 22 4 19.985 4 17.5C4 15.015 7.582 13 12 13C16.418 13 20 15.015 20 17.5Z" stroke="var(--c7)" strokeWidth="1.5" style={{ stroke: "white" }}/></svg>
        <span>ورود / عضویت</span>
    </button>

</div>




                        </Grid>


                    </Grid>







                </Fragment>


            </Master_Front>

        </>
    );
}


export default Login_Message;